export { SUBSCRIBE_ALL, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';
export var TenantType;

(function (TenantType) {
  TenantType["RealUser"] = "real-user";
  TenantType["Synthetic"] = "synthetic";
})(TenantType || (TenantType = {}));